import { WithTooltip } from "components/blocks/WithTooltip";
import { COLORS } from "styles/colors";
import { Text } from "components/atoms/text/Text";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOpenInNew } from "react-icons/md";
import { IoMdDownload } from "react-icons/io";
import { PiFilePdf } from "react-icons/pi";
import { HelpGuide } from "hook/useHelpGuideApi";
import { downloadFromUrl, openNewWindow } from "utils/functions";

interface TableListItemProps {
  guide: HelpGuide;
  onClickGuideItem: (guide: HelpGuide) => void;
  showAtTop?: boolean;
}

const ListItemPdf = ({
  guide,
  onClickGuideItem,
  showAtTop,
}: TableListItemProps) => {
  return (
    <tr>
      <td className="file-type">
        <PiFilePdf />
      </td>
      <td className="title">
        <Text>{guide.title}</Text>
      </td>
      <td className="description">
        <Text color={COLORS.BUTTONS1} fontSize={14}>
          {guide.description}
        </Text>
      </td>
      <td>
        <div className="actions">
          <WithTooltip tooltip="Open in modal" showAtTop={showAtTop}>
            <button
              onClick={() => onClickGuideItem(guide)}
              data-testid="help-video-guides-item-button-click-guide-item"
            >
              <HiOutlineBookOpen />
            </button>
          </WithTooltip>
          <WithTooltip tooltip="Open in new tab" showAtTop={showAtTop}>
            <button
              onClick={() => openNewWindow(guide.resourceUrl)}
              data-testid="help-video-guides-item-button-open-new-window"
            >
              <MdOpenInNew />
            </button>
          </WithTooltip>
          <WithTooltip tooltip="Download" showAtTop={showAtTop}>
            <button
              onClick={() =>
                downloadFromUrl(guide.resourceUrl, guide.fileName ?? "")
              }
              data-testid="help-video-guides-item-button-download-from-url"
            >
              <IoMdDownload />
            </button>
          </WithTooltip>
        </div>
      </td>
    </tr>
  );
};

export default ListItemPdf;
